'use strict';

exports.__esModule = true;
exports.default = {
  BLUE: 'blue',
  WHITE: 'white'
}; //# sourceMappingURL=MessengerColor.js.map